import React from 'react';

import NavBar, { View } from './NavBar';
import { Alert } from '@vivaahealth/design-system';

import * as logger from '../logger';

import appStyles from '../scenes/App.module.css';
import styles from '../scenes/FormStart/index.module.css';

interface Props {
  children: React.ReactNode;
  renderOnError?: () => React.ReactNode;
}

interface State {
  hasError: boolean;
}

const DefaultErrorPage = () => (
  <div className={appStyles.App}>
    <NavBar view={View.Login} />
    <div className={styles.FormContainer}>
      <div className={styles.Form}>
        <div className={styles.PageWrapper}>
          <div style={{ display: 'flex' }}>
            <Alert
              variant="danger"
              title="An unexpected error happened"
              error={{
                name: 'error',
                message:
                  'Something went wrong. Please refresh the page and try again.',
              }}
            />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default class ErrorBoundary extends React.Component<Props, State> {
  state = {
    hasError: false,
  };

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    this.setState({ hasError: true });
    console.error(error, errorInfo);
    logger.error(
      error,
      `[ErrorBoundary]: ran into error=${error} errorInfo=${errorInfo}`,
    );
  }

  render() {
    if (this.state.hasError) {
      return this.props.renderOnError ? (
        this.props.renderOnError()
      ) : (
        <DefaultErrorPage />
      );
    }

    return this.props.children;
  }
}
